import React from 'react'
import {connect} from 'react-redux'
import '../../css/page/DetailsSharePage.css'

import successTips from '../../images/shareSuccess.png'
import { prodConfig } from '../../config'

class ArticlePart extends React.Component{
    constructor(){
        super();
    }
    render(){
        return(
            <div className="articlePart" onClick={() => {
                window.MtaH5 && window.MtaH5.clickStat(`share_success_${this.props.id}`);
                window._czc && window._czc.push(["_trackEvent", 'common', 'click', `share_success_${this.props.id}`, 1])
                window.location = this.props.link
            }}>
                <img src={this.props.url} alt=""/>
                <div className="article">
                    <div className="articleTitle">
                        {this.props.articleTitle}
                    </div>
                    <p>{this.props.author}</p>
                </div>
            </div>
        )
    }
}

class ShareSuccessPage extends React.Component{
    constructor(){
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleClickStop = this.handleClickStop.bind(this);
        this.state = {
            list: [
                {
                    id: '133054',
                    url: 'https://static-1253442168.image.myqcloud.com/channel_cover/cover_133054_d944397d7774ac84808d4a4d03bb5b34.jpg-lecturecover85hd',
                    articleTitle: '拿走直接用：36个小而美赚钱项目，让你月入10万！',
                    author: '智囊圈',
                    link: `${prodConfig.MAIN_URL}/channel/133054?st=lzwk_inside&inviter_id=50005711`
                },
                {
                    id: '134821',
                    url: 'https://static-1253442168.image.myqcloud.com/channel_cover/cover_134821_fc04e3230e88e4588c60a3862536e639.jpg-lecturecover85hd',
                    articleTitle: '北大心理学女神：20个策略沟通术，让你一开口就赢得人心！',
                    author: '奇计学院',
                    link: `${prodConfig.MAIN_URL}/channel/134821?st=lzwk_inside&inviter_id=50005711`
                },
                {
                    id: '132501',
                    url: 'https://static-1253442168.image.myqcloud.com/channel_cover/cover_132501_c337f851ff566cd19c7529a80af7ce16.jpg-lecturecover85hd',
                    articleTitle: '福布斯精英文豪：投资理财8节课，让你真正学会钱生钱！',
                    author: '文豪商学院',
                    link: `${prodConfig.MAIN_URL}/channel/132501?st=lzwk_inside&inviter_id=50005711`
                }
            ]
        }
    }
    handleClick(){
        window.MtaH5 && window.MtaH5.clickStat('share_success_close');
        window._czc && window._czc.push(["_trackEvent", 'common', 'click', 'share_success_close', 1])
        this.props.dispatch({
            type: 'DEEP_SHARE_DIALOG_HIDE'
        })
    }
    handleClickStop(e){
        e.stopPropagation();
    }
    render(){
        const {showShareDialog} = this.props.details
        if (!showShareDialog) {
            return null
        }
        window.MtaH5 && window.MtaH5.clickStat('share_success_show');
        window._czc && window._czc.push(["_trackEvent", 'common', 'click', 'share_success_show', 1])
        return(
            <div className="bgBox" onClick={this.handleClick}>
                <div className="containBox" onClick={this.handleClickStop}>
                    <div className="titleBox">
                        <img src={successTips} alt="" className="successTips"/>
                        <span>分享成功</span>
                    </div>
                    <div className="contentBox">
                        <div className="contentBox__title">
                            大家都在听：
                        </div>
                        <div className="articleBox">
                            {this.state.list.map((item, index) => <ArticlePart key={`share_list_${index}`} id={item.id} url={item.url} articleTitle={item.articleTitle} author={item.author} link={item.link} />)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



export default connect(state => ({
    account: state.account,
    details: state.details,
}))(ShareSuccessPage);


// WEBPACK FOOTER //
// ./src/components/details/ShareSuccessPage.js